<template>
	<div class="event-card-actions">
		<button
			v-if="bookmarkEnabled"
			type="button"
			class="event-card-actions__button -save"
			:class="{ 'is-bookmarked': isBookmarked }"
			:aria-label="bookmarkLabel"
			:aria-pressed="isBookmarked ? 'true' : 'false'"
			@click="isBookmarked ? handleUnsave() : handleSave()"
		>
			<Tooltip
				v-if="!isTouchDevice"
				:text="isBookmarked ? $I18n.trans('event.messages.remove_from_saved') : $I18n.trans('event.messages.save_event')"
				:delay="1000"
				position="top-center"
			>
				<template #toggle>
					<Icon
						:icon-name="isBookmarked ? 'bookmark-filled' : 'bookmark-outline'"
						class="bookmark-icon"
						size="lg"
					/>
				</template>
			</Tooltip>
			<Icon
				v-else
				:icon-name="isBookmarked ? 'bookmark-filled' : 'bookmark-outline'"
				class="bookmark-icon"
				size="lg"
			/>
		</button>
		<button
			v-if="sharingEnabled"
			type="button"
			class="event-card-actions__button"
			:aria-label="shareLabel"
			@click="handleShare"
		>
			<Icon
				icon-name="network-communication"
				size="lg"
			/>
		</button>
		<VideoDownload
			v-if="videoDownloadEnabled"
			:event="event"
		/>
		<a
			v-if="videoCroppingEnabled"
			class="event-card-actions__button"
			:href="laroute.route('arena.event.multiformat', {event: event.id})"
			:aria-label="momentsLabel"
		>
			<Icon
				icon-name="formatconverter"
				size="lg"
			/>
		</a>
	</div>
</template>

<script>
import Icon from '@shared/components/Icon';
import VideoDownload from '@shared/components/VideoDownload';
import Tooltip from '@shared/components/Tooltip';
import laroute from '@laroute';

export default {
	name:       'EventCardActions',
	components: {
		Icon,
		VideoDownload,
		Tooltip,
	},
	props: {
		videoCroppingEnabled: {
			type:    Boolean,
			default: false,
		},
		videoDownloadEnabled: {
			type:    Boolean,
			default: false,
		},
		bookmarkEnabled: {
			type:    Boolean,
			default: false,
		},
		sharingEnabled: {
			type:    Boolean,
			default: false,
		},
		event: {
			type:     Object,
			required: true,
		},
		isBookmarked: {
			type:    Boolean,
			default: false,
		},
		isTouchDevice: {
			type:    Boolean,
			default: false,
		},
	},
	data() {
		return {
			laroute,
		};
	},
	computed: {
		bookmarkLabel() {
			const action = this.isBookmarked
				? this.$I18n.trans('event.messages.remove_from_saved')
				: this.$I18n.trans('event.messages.save_event');
			return `${action}: ${this.event.name}`;
		},
		shareLabel() {
			return `${this.$I18n.trans('commons.share_event')}: ${this.event.name}`;
		},
		momentsLabel() {
			return `${this.$I18n.trans('event.multiformat_editor.title')}: ${this.event.name}`;
		},
	},
	methods: {
		handleShare() {
			this.$emit('share');
		},
		handleSave() {
			this.$emit('save');
		},
		handleUnsave() {
			this.$emit('unsave');
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.event-card-actions {
	display: flex;
	gap: $sp4;
	color: var(--color-grey-300);
	padding: 0 $sp4;
}

.event-card-actions__button {
	cursor: pointer;
}

</style>
